import { ExceptionRecord, ExceptionTraceStep } from '../../services/device.service';

export interface ExceptionsState {
  exceptions: ExceptionRecord[];
  loading: boolean;
  started: boolean;
  error: string | null;
  totalCount: number;
  servicesFailed: string[];
  loadedServicesCount: number;
  totalServicesCount: number;
  /** ISO timestamp set when the stream completes — component uses this to compute lastRefreshedAt. */
  streamCompletedAt: string | null;
  /** Trace steps keyed by operation_id. */
  traces: Record<string, ExceptionTraceStep[]>;
  traceLoadingIds: string[];
  traceErrors: Record<string, string>;
}

export const initialExceptionsState: ExceptionsState = {
  exceptions: [],
  loading: false,
  started: false,
  error: null,
  totalCount: 0,
  servicesFailed: [],
  loadedServicesCount: 0,
  totalServicesCount: 0,
  streamCompletedAt: null,
  traces: {},
  traceLoadingIds: [],
  traceErrors: {},
};
